import FooterDesktop from "@Components/FooterV2/FooterDesktop";
import FooterV2 from "@Components/FooterV2/FooterV2";
import { Helmet } from "react-helmet";
import ZendeskChat from "@Pages/PropertyPage/components/ZendeskChat";
import wrapperHOC from "@Utils/wrapperHOC";
import { logAppEvent } from "@Utils/appAnalytics";
import { APP_EVENTS, APP_PAGE } from "@Utils/webApputils/analyticEvents";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { useSelector } from "react-redux";
import { AppState } from "@Store/index";
import HeroV2 from "../components/HeroV2/HeroV2";
import ScholarshipVideo from "../components/ScholarshipVideo";
import DreamerTypes from "../components/DreamerTypes";
import ScholarshipHowToApply from "../components/ScholarshipHowToApply";
import ScholarshipJudgement from "../components/ScholarshipJudgement";
import ScholarshipTestimonials from "../components/ScholarshipTestimonials";
import ScholarshipFAQ from "../components/ScholarshipFAQ";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";
import ScholarshipTermsNotice from "../components/ScholarshipTermsNotice";
import GetHelpDesktop from "@Pages/Home/components/GetHelpDesktop";
import GetHelp from "@Pages/Home/components/GetHelp";
import { useResponsiveness } from "hooks/useResponsiveness";
import { useState, useEffect } from "react";
import { ScholarshipFormContext, ScholarshipFormModal } from "../ScholarshipFormModal";
import styles from "./ScholarshipDesktop.module.scss";
import useTranslationHook from "hooks/useTranslationHook";

const ScholarshipDesktop = () => {
  const { isAbove } = useResponsiveness();
  const isLargeDesktop = isAbove("lg"); // above 1200px
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { t } = useTranslationHook();
  const { lastScreen, isUserLoggedIn } = useSelector(({ appData }: AppState) => ({
    lastScreen: appData.lastScreen,
    isUserLoggedIn: appData.isUserLoggedIn,
  }));

  useEffect(() => {
    gtagEventEmitter({
      action: APP_EVENTS.PAGE_VIEWED,
      category: "route",
      screen: APP_PAGE.SCHOLARSHIP,
      page_path: window.location.pathname,
      page_url: window.location.href,
    });
    logAppEvent({
      eventName: APP_EVENTS.PAGE_VIEWED,
      payload: {
        screen: APP_PAGE.SCHOLARSHIP,
        previous_screen: lastScreen,
        is_logged_in: isUserLoggedIn,
      },
    });
  }, []);

  useEffect(() => {
    if (isFormOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isFormOpen]);

  const openForm = () => {
    logAppEvent({
      eventName: APP_EVENTS.CTA_CLICKED,
      payload: {
        cta_name: "scholarship_apply_now",
        page: APP_PAGE.SCHOLARSHIP,
        is_logged_in: isUserLoggedIn,
        version: "old",
      },
    });
    gtagEventEmitter({
      action: "scholarships_cta_click",
      category: "scholarship",
    });
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({ event: "scholarship-apply-clicked" });
    }
    // Meta Pixel - SubmitApplication standard event (Pixel ID: 296478883208201)
    if (typeof (window as any).fbq !== "undefined" && (window as any).fbq !== null) {
      (window as any).fbq("track", "SubmitApplication");
    }
    setIsFormOpen(true);
  };

  return (
    <ScholarshipFormContext.Provider value={{ openForm }}>
      <div className={styles.scholarshipDesktopContainer}>
        <Helmet title={t("scholarship.meta.title")}>
          <meta name="description" content={t("scholarship.meta.description")} />
        </Helmet>
        <HeroV2 isScholarshipPage />
        <ScholarshipVideo />
        <div className={styles.sectionSeparator} />
        <DreamerTypes />
        <div className={styles.sectionSeparator} />
        <ScholarshipJudgement />
        <div className={styles.sectionSeparator} />
        {/* <ScholarshipPrizes /> */}
        <ScholarshipHowToApply />
        <div className={styles.sectionSeparator} />
        <ScholarshipTestimonials />
        <div className={styles.sectionSeparator} />
        <ScholarshipFAQ />
        <ScholarshipTermsNotice />
        {isLargeDesktop ? <GetHelpDesktop /> : <GetHelp />}
        {isLargeDesktop ? <FooterDesktop /> : <FooterV2 />}
        <AmberCopilotWrapper />
        <ZendeskChat />
        <ScholarshipFormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
      </div>
    </ScholarshipFormContext.Provider>
  );
};

export default wrapperHOC(ScholarshipDesktop, {
  componentName: "ScholarshipDesktop",
  showForChina: true,
});
